import { SAVE_BRANCH_ACTION,GET_ALL_BRANCHES_SUCCESS_ACTION,GET_ALL_BRANCHES_REQUEST_ACTION} from "./Constants";

const INTIAL_STATE = {
  branchId: 1,
  request:false,
  branches:[]
};

export default function headerReducer(state = INTIAL_STATE, action) {
  switch (action.type) {
    case GET_ALL_BRANCHES_REQUEST_ACTION:
  return{
    ...state,
    request:true,
  }
    case GET_ALL_BRANCHES_SUCCESS_ACTION:
      return{
        ...state,
        request:false,
        branches:action.data.branches,
      }
    case SAVE_BRANCH_ACTION:
      return {
        ...state,
        branchId: action.branchId
      };
    default:
      return state;
  }
}
